import { SVGMotionProps, motion } from 'framer-motion'
import { FC } from 'react'

export const CloseIcon: FC<SVGMotionProps<SVGSVGElement>> = (props) => (
	<motion.svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M18 6L6 18" stroke="var(--icon-color, var(--color--blue))" strokeWidth="2" strokeMiterlimit="10" />
		<path d="M6 6L18 18" stroke="var(--icon-color, var(--color--blue))" strokeWidth="2" strokeMiterlimit="10" />
	</motion.svg>
)
